import Container from "@mui/material/Container";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";

import { useTranslation } from "react-i18next";
import { useRouteError } from "react-router";
import illustration from "../../assets/not-found.svg";

const NotFound = () => {
	const { t } = useTranslation();
	const error = useRouteError();

	console.log("Error occurred:", error);

	return (
		<>
			<CssBaseline />
			<Container
				sx={{
					backgroundColor: "#084170",
					height: "100vh",
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignItems: "center",
				}}
				maxWidth={false}
			>
				<img src={illustration} alt="Not Found" style={{ maxWidth: "800px" }} />
				{error.status === 404 ? (
					<>
						<Typography
							variant="h3"
							sx={{ color: "#fff", mt: "-40px", mb: "40px" }}
						>
							{t("not_found_page_info")}
						</Typography>
					</>
				) : (
					<>
						<Typography
							variant="h3"
							sx={{ color: "#fff", mt: "-40px", mb: "40px" }}
						>
							{error.statusText}
						</Typography>
						<Typography
							variant="h4"
							sx={{ color: "#fff", mt: "-40px", mb: "40px" }}
						>
							{error.message}
						</Typography>
						<Typography
							variant="h5"
							sx={{ color: "#fff", mt: "-40px", mb: "40px" }}
						>
							{JSON.stringify(error, null, 2)}
						</Typography>
					</>
				)}
			</Container>
		</>
	);
};

export default NotFound;
